import { first, OperatorFunction, TruthyTypesOf } from 'rxjs';

/**
 * Only emit first truthy value
 */
export function firstTruthy<T>(): OperatorFunction<T, TruthyTypesOf<T>> {
    return (source$) => source$.pipe(first(Boolean));
}
